import React from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import { NavLink, useNavigate } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Icone from 'Component/Icone';
import Imagem from 'Component/Imagem';
import { logout as logoutAction } from 'Reducer/Autenticacao';
import { useLogoutMutation } from 'Service';
import { useAppDispatch, useAppSelector } from 'Store';

const MenuLateral = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const dispatch = useAppDispatch();
  const [logout] = useLogoutMutation();

  const sair = async (): Promise<void> => {
    try {
      await logout().unwrap();

      dispatch(logoutAction());

      navegacao('/login');
    } catch (erro) {
      toast({
        titulo: 'Erro ao fazer logout',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <React.Fragment>
      <BrowserView className="h-100">
        <div
          className="h-100 d-flex flex-column flex-shrink-0 p-3 text-body bg-white shadow-lg overflow-auto"
          style={{ width: '280px' }}
        >
          <a href="/" className="d-block">
            <Imagem src="logo.png" height="50" className="d-block mx-auto" />
          </a>
          <ul className="nav nav-pills flex-column mb-auto mt-4">
            <li className="nav-item">
              <NavLink
                to="/inicio"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="house-fill" className="me-2" />
                Início
              </NavLink>
            </li>
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/alertas"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="exclamation-triangle-fill" className="me-2" />
                  Alertas
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/empresas"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="briefcase-fill" className="me-2" />
                  Empresas
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/departamentos"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="person-rolodex" className="me-2" />
                  Departamentos
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/funcoes"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="person-lines-fill" className="me-2" />
                  Funções
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/usuarios"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="person-badge-fill" className="me-2" />
                  Funcionários
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/avaliacoes-experiencias"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="file-earmark-medical-fill" className="me-2" />
                  Avali. do p. experiência
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/avaliacoes-desempenho"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="file-earmark-medical-fill" className="me-2" />
                  Avali. desempenho
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/relogios-de-ponto"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="alarm-fill" className="me-2" />
                  Relógio de ponto
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/fechamentos-de-folha"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="currency-dollar" className="me-2" />
                  Fechamento de folha
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/holerites"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="cash-coin" className="me-2" />
                  Holerites
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/calculadora"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="calculator-fill" className="me-2" />
                  Calculadora de Turnover
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/categorias-de-curriculo"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="file-earmark-check-fill" className="me-2" />
                  Categorias de Currículo
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/curriculos"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="file-earmark-text-fill" className="me-2" />
                  Currículos
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/comunicados"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="megaphone-fill" className="me-2" />
                  Comunicados
                </NavLink>
              </li>
            )}
            <li className="nav-item">
              <NavLink
                to="/indisponibilidades"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="balloon-fill" className="me-2" />
                Férias e folgas
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/treinamentos"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="person-workspace" className="me-2" />
                Treinamentos
              </NavLink>
            </li>
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/uniformes"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="universal-access" className="me-2" />
                  Uniformes
                </NavLink>
              </li>
            )}
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/epis"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="cone-striped" className="me-2" />
                  EPIs
                </NavLink>
              </li>
            )}
            <li className="divider">
              <hr />
            </li>
            <li className="nav-item">
              <NavLink
                to="/holerites/historico"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="cash-coin" className="me-2" />
                Histórico de holerites
              </NavLink>
            </li>
            {usuario && ['super', 'admin'].includes(usuario.permissao) && (
              <li className="nav-item">
                <NavLink
                  to="/fechamentos-de-folha/historico"
                  className={({ isActive }) =>
                    `nav-link ${isActive && 'text-white active'}`
                  }
                >
                  <Icone nome="currency-dollar" className="me-2" />
                  Histórico de fecha. folha
                </NavLink>
              </li>
            )}
            <li className="nav-item">
              <NavLink
                to="/relogios-de-ponto/historico"
                className={({ isActive }) =>
                  `nav-link ${isActive && 'text-white active'}`
                }
              >
                <Icone nome="alarm-fill" className="me-2" />
                Histórico de rel. ponto
              </NavLink>
            </li>
          </ul>
          <hr />
          <div className="dropdown dropend">
            <a
              href="#"
              className="d-flex align-items-center text-body text-decoration-none"
              data-bs-toggle="dropdown"
            >
              <Imagem
                src={usuario?.imagem}
                width="40"
                height="40"
                className="rounded-circle me-2"
              />
              <strong>
                {usuario?.nome}
                <small className="d-block fw-light">{usuario?.email}</small>
              </strong>
            </a>
            <ul className="dropdown-menu text-small border-0 shadow">
              <li>
                <button
                  type="button"
                  className="dropdown-item"
                  onClick={() => navegacao('/alterar-senha')}
                >
                  Alterar senha
                </button>
              </li>
              <li>
                <button type="button" className="dropdown-item" onClick={sair}>
                  Sair
                </button>
              </li>
            </ul>
          </div>
        </div>
      </BrowserView>
      <MobileView>
        <nav
          id="navbar-footer"
          className="navbar navbar-expand fixed-bottom navbar-light border-top bg-white p-0 z-index-500"
        >
          <ul className="navbar-nav w-100 d-flex justify-content-between">
            <li className="nav-item" style={{ flex: 1 }}>
              <NavLink
                to="/inicio"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="house-fill" className="mb-1 fs-5" />
                <small className="d-block">Início</small>
              </NavLink>
            </li>
            <li className="nav-item" style={{ flex: 1 }}>
              <NavLink
                to="/indisponibilidades"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="balloon-fill" className="mb-1 fs-5" />
                <small className="d-block">Folgas</small>
              </NavLink>
            </li>
            <li className="nav-item" style={{ flex: 1 }}>
              <NavLink
                to="/holerites/historico"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="cash-coin" className="mb-1 fs-5" />
                <small className="d-block">Holerites</small>
              </NavLink>
            </li>
            <li className="nav-item" style={{ flex: 1 }}>
              <NavLink
                to="/fechamentos-de-folha/historico"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="currency-dollar" className="mb-1 fs-5" />
                <small className="d-block">Folha</small>
              </NavLink>
            </li>
            <li className="nav-item" style={{ flex: 1 }}>
              <NavLink
                to="/relogios-de-ponto/historico"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="alarm-fill" className="mb-1 fs-5" />
                <small className="d-block">Ponto</small>
              </NavLink>
            </li>
            <li
              className="nav-item d-flex align-items-center justify-content-center"
              style={{ flex: 1 }}
            >
              <NavLink
                to="/menu"
                className={({ isActive }) =>
                  `nav-link text-center ${isActive && 'text-primary'}`
                }
              >
                <Icone nome="list" className="mb-1 fs-5" />
              </NavLink>
            </li>
          </ul>
        </nav>
      </MobileView>
    </React.Fragment>
  );
};

export default MenuLateral;
